// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-container[data-v-aced6a9c],.news-section[data-v-aced6a9c]{opacity:1;visibility:visible;transition:.5s ease}.news-container.hide[data-v-aced6a9c],.news-section.hide[data-v-aced6a9c]{opacity:0;visibility:hidden;transition:.5s ease}", ""]);
// Exports
module.exports = exports;
